export enum EUserRole {
  SUPER_ADMIN,
  ADMIN,
  DOCTOR,
  PATIENT,
}
